import React from 'react'
import { workInProgressStyle as styles } from "./purchaseHistory.tailwind";
import shopping_bag from '../../assets/svgs/shopping_bag.svg';
import routeConstant from '../../lib/constants/routeConstant';
import Button from '../shared/Button/Button';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setMyAccountActiveTab } from '../../redux/slices/publicSlice';
import { MY_ACCOUNT_TABS } from '../MyAccount/myAccountTabsData';

const NoDataFound = ({ isToken = false, setActiveTab }) => {
    const navigate = useNavigate();

    const handleBuyPoints = () => {
        navigate(routeConstant.MY_ACCOUNT_PAGE, { state: { openPaymentModal: true } });
        setActiveTab(MY_ACCOUNT_TABS.REDEEM_REWARDS)
    }

    const handleExploreTokens = () => {
        navigate(routeConstant.SELECT_SPORT_PAGE);
    }

    return (
        <div className={styles.noPurchaseHistory}>
            <img src={shopping_bag} alt="Shop Now" className={styles.noPurchaseImg} />
            <span className='text-center mb-[20px]'>You haven&apos;t {isToken ? 'made' : 'bought'} any {isToken ? 'purchases' : 'points'} yet.</span>
            
            {isToken && <Button variant="primary" onClick={handleExploreTokens}>Explore Tokens</Button>}

            {!isToken && <Button variant="primary" onClick={handleBuyPoints}>Buy Points</Button>}
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    setActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
  });
  
  export default connect(null, mapDispatchToProps)(NoDataFound);